import React, { useState } from 'react';
import PaginationComponent from '../components/pagination/PaginationComponent';
import { MdClose, MdEdit } from 'react-icons/md';
import UpdateMeeting from './dashboard/UpdateMeeting';

const TableData = ({ meetings, fetchMeetings }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedAttendees, setSelectedAttendees] = useState([]);
    const [selectedOwner, setSelectedOwner] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
    const [selectedMeeting, setSelectedMeeting] = useState(null);

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        return date.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        });
    };

    const openPopup = (attendees, owner) => {
        setSelectedAttendees(attendees);
        setSelectedOwner(owner.toUpperCase());
        setIsPopupOpen(true);
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);  // Reset to first page when items per page changes
    };

    const closePopup = () => {
        setIsPopupOpen(false);
    };

    // Logic for paginated meetings
    const indexOfLastMeeting = currentPage * itemsPerPage;
    const indexOfFirstMeeting = indexOfLastMeeting - itemsPerPage;
    const currentMeetings = meetings?.slice(indexOfFirstMeeting, indexOfLastMeeting);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
    };

    const handleUpdateClick = (meeting) => {
        setSelectedMeeting(meeting);
        setIsUpdateModalOpen(true);
    };
    const closeUpdateModal = () => {
        setIsUpdateModalOpen(false);
        setSelectedMeeting(null);
    };

    return (
        <>
            <div className="table-container">
                <div className="table-wrapper">
                    <table className="custom-table">
                        <thead >
                            <tr>
                                <th>Owner</th>
                                <th>Meeting Title</th>
                                <th>Time Slot</th>
                                <th>Meeting Date</th>
                                <th>Attendees</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentMeetings?.length > 0 ? (
                                currentMeetings.map((el, index) => {
                                    return (
                                        <tr key={el.id || index} className='row'>
                                            <td style={{ textTransform: "capitalize" }}>{el.owner}</td>
                                            <td>{el.title}</td>
                                            <td>{`${formatDateTime(el.slot_start_time)} - ${formatDateTime(el.slot_end_time)}`}</td>
                                            <td>{formatDate(el.slot_start_time)}</td>

                                            <td>
                                                <button
                                                    onClick={() => openPopup(el.attendies, el.owner)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        padding: '5px 10px',
                                                        border: 'none',
                                                        background: '#04a5e8',
                                                        color: '#fff',
                                                        borderRadius: '5px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    View
                                                    {/* {el.attendies.length} */}
                                                </button>
                                            </td>
                                            <td
                                                className={
                                                    el.status === "completed"
                                                        ? "status-completed"
                                                        : el.status === "upcoming"
                                                            ? "status-upcoming"
                                                            : el.status === "Ongoing"
                                                                ? "status-Ongoing"
                                                                : ""
                                                }
                                            >
                                                {el.status}
                                            </td>
                                            <td >
                                              <div className="update-me">
                                              <button disabled={el.isUpdate==false} style={{background:el.isUpdate==false?"#dbdbdb":"",cursor:el.isUpdate==false?"default":""}} type='button' className="update-button" onClick={() => handleUpdateClick(el)}>
                                                    <MdEdit className='icon-edit'/>
                                                </button>
                                              </div>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="5" className="no-data">No meetings found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {
                    isUpdateModalOpen && <UpdateMeeting
                        onClose={closeUpdateModal}
                        fetchMeetings={ fetchMeetings}
                        meetingIdData={selectedMeeting}
                        
                    />
                }

                {isPopupOpen && (
                    <div className="popup-overlay" >
                        <div className="popup">
                            <div className="pop-close-btn-new">
                                <button className="popup-close-btn" onClick={closePopup}><MdClose /></button>
                            </div>
                            <h3 className="popup-title">Organizer: <span>{selectedOwner}</span></h3>
                            <ol className="popup-list">
                                {selectedAttendees.length > 0 ? (
                                    selectedAttendees.map((attendee, idx) => (
                                        <li className="list-data" key={idx}>
                                            <span className="attendee-icon">👤</span>
                                            <div className="attendee-info">
                                                <span className="attendee-name">{attendee.user_name}</span>
                                            </div>
                                            <span className="">/</span>

                                            <div className=''>
                                                <span className="attendee-designation">{attendee.designation}</span>

                                            </div>
                                        </li>

                                    ))
                                ) : (
                                    <li className="list-data">No attendees</li>
                                )}
                            </ol>

                        </div>
                    </div>
                )}
            </div>

            <PaginationComponent
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handleItemsPerPageChange={handleItemsPerPageChange}
                totalPages={Math.ceil(meetings?.length / itemsPerPage)} // Corrected: Use meetings.length
                handlePageChange={handlePageChange}
                isNextDisabled={currentPage === Math.ceil(meetings?.length / itemsPerPage)}
            />
        </>
    );
};

export default TableData;
